import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/yacht-equipment-packs', data)
    .then(response => {
      return response.data
    })
}
function update(data, id) {
  return axios.patch(`/yacht-equipment-packs/${id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  fetch(params) {
    return axios.get('/yacht-equipment-packs', { params: params })
      .then(response => {
        return response.data
      })
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  massEdit(data) {
    return axios.post('/yacht-equipment-packs/mass-edit', data).then(response => response.data)
  },
  find(id) {
    return axios.get(`/yacht-equipment-packs/${id}`).then(response => response.data)
  },
  destroy(id) {
    return axios.delete(`/yacht-equipment-packs/${id}`)
  },
  massImport(options) {
    return axios.get(`/yacht-equipment-packs/mass-import`, {
      params: options
    }).then(response => response.data)
  },
  fetchPivot(params) {
    return axios.get('/yacht-pivot-equipment-packs', { params: params })
      .then(response => {
        return response.data
      })
  },
  sendOrders(data) {
    return axios.post('/yacht-equipment-packs/send-order', data).then(response => response.data)
  }
}
